import React, { useEffect, useState } from "react";
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-js-pagination";
import { Button } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";
import { getAllDirectorReports } from "src/redux/actions/customerAction";
import Vakilkaro from "src/assets/brand/vakilkaro";
import { CSVLink } from "react-csv";
import { COMPANY_NAME } from "src/services/const";
// import SearchHook from "src/components/SearchHook";
import PropTypes from "prop-types";
import { getAllDirectorsReports } from "src/api/allApis";

const DirectorReports = (props) => {
  const { pageFor } = props;
  const componentPDF = useRef();
  const dispatch = useDispatch();
  //   const { newDirectorCreated } = useSelector((state) => state?.customerReducer);
  const [showAddForm, setShowAddForm] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchInput, setSearchInput] = useState("");
  //   const [directorData, setDirectorData] = useState(false);
  const [printState, setPrintState] = useState(false);
  const SchemaName = sessionStorage.getItem("schemaName");
  const { Directors } = useSelector((state) => state?.customerReducer);
  //   const investorType = pageFor === "directors" ? "director" : "investor"
  //   const Directors = { data: (DirectorData?.data || []).filter((item) => item.investor === investorType) }
  useEffect(() => {
    const obj = { schemaName: SchemaName };
    getAllDirectorsReports(obj);
  }, []);

  useEffect(() => {
    setShowAddForm(false);
    // setDirectorData(false);
    setPrintState(false);
  }, [pageFor]);

  useEffect(() => {
    if (printState) {
      generatePDF();
    }
  }, [printState]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(e.target.value);
    setCurrentPage(1);
  };

  const download_btn = () => {
    setPrintState(true);
  };
  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "userData",
    onAfterPrint: () => setPrintState(false),
  });

  const handleSearchChange = (e) => {
    setSearchInput(e.target.value);
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = Directors?.data?.slice(indexOfFirstRow, indexOfLastRow);

  const modifiedRows = currentRows?.map((row) => {
    const {
      capitalAccounts,
      company,
      companyName,
      directorName,
      companyId,
      id,
      schemaName,
      interest,
      investor,
      capital,
      updatedAt,
      ...rest
    } = row;
    return {
      Name: directorName,
      "Investors/Director": investor,
      ...rest,
    };
  });

  return (
    <>
      <CRow className="content">
        <CCol xs={12}>
          <CCard className="mb-4">
            <CCardHeader>
              <strong>
                {props?.pageFor === "directors" ? "Directors" : "Investors"}{" "}
                Details
              </strong>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol xs={12}>
                  <CCard className="mb-2">
                    <div className="search_bar">
                      {/* <SearchHook
                        handleRowsPerPageChange={handleRowsPerPageChange} // ✅ Pass the function reference
                        handleSearchChange={handleSearchChange}
                        searchInput={searchInput}
                      /> */}
                      <div className="btn_add mt-0 mb-14 ">
                        <Button
                          className="add-btn mr-10 w-auto"
                          onClick={download_btn}
                        >
                          Download
                        </Button>

                        <CSVLink
                          data={modifiedRows === undefined ? " " : modifiedRows}
                          filename={"director-table.csv"}
                        >
                          <CButton className="add-btn m-0 w-auto">CSV</CButton>
                        </CSVLink>
                      </div>
                    </div>
                    <CCardBody>
                      <div
                        className={`table-container  ${
                          showAddForm ? "hidden" : ""
                        }`}
                      >
                        <div
                          className="mb-2"
                          ref={printState ? componentPDF : null}
                          style={{ padding: printState ? "20px" : "0px" }}
                        >
                          {printState && (
                            <div className="print-div">
                              <div>
                                <Vakilkaro />
                              </div>
                              <div>
                                <p>{COMPANY_NAME}</p>
                              </div>
                            </div>
                          )}
                          <CTable color="dark" hover responsive>
                            <CTableHead className="tabl-head">
                              <CTableRow className="table-row">
                                <CTableHeaderCell
                                  scope="col"
                                  className="col-md-1"
                                >
                                  S. No.
                                </CTableHeaderCell>
                                {pageFor === "directors" && (
                                  <CTableHeaderCell
                                    scope="col"
                                    className="col-md-2"
                                  >
                                    DIN Number
                                  </CTableHeaderCell>
                                )}
                                <CTableHeaderCell
                                  scope="col"
                                  className="col-md-2"
                                >
                                  Name
                                </CTableHeaderCell>
                                <CTableHeaderCell
                                  scope="col"
                                  className="col-md-2"
                                >
                                  Director/Investor
                                </CTableHeaderCell>

                                <CTableHeaderCell
                                  scope="col"
                                  className="col-md-2"
                                >
                                  Email
                                </CTableHeaderCell>
                                <CTableHeaderCell
                                  scope="col"
                                  className="col-md-2"
                                >
                                  Phone Number
                                </CTableHeaderCell>
                                <CTableHeaderCell>
                                  Total Capital
                                </CTableHeaderCell>
                                <CTableHeaderCell>
                                  Total Loan Amount
                                </CTableHeaderCell>
                                <CTableHeaderCell>
                                  capital paid
                                </CTableHeaderCell>
                                <CTableHeaderCell>
                                  loan amount paid
                                </CTableHeaderCell>
                                <CTableHeaderCell>
                                  Interest paid
                                </CTableHeaderCell>

                                <CTableHeaderCell>
                                  capital Balance
                                </CTableHeaderCell>
                                <CTableHeaderCell>
                                  loan Amount Balance
                                </CTableHeaderCell>
                              </CTableRow>
                            </CTableHead>
                            <CTableBody>
                              {Directors?.data && Directors?.data.length > 0 ? (
                                currentRows
                                  ?.filter((item) =>
                                    item.directorName
                                      .toLowerCase()
                                      .includes(searchInput.toLowerCase())
                                  )
                                  .map((datas, index) => {
                                    return (
                                      <CTableRow key={index}>
                                        <CTableDataCell>
                                          {indexOfFirstRow + index + 1}
                                        </CTableDataCell>
                                        {pageFor === "directors" && (
                                          <CTableDataCell>
                                            {datas?.din ? datas?.din : "--"}
                                          </CTableDataCell>
                                        )}
                                        <CTableDataCell>
                                          {datas?.directorName
                                            ? datas?.directorName
                                            : "--"}
                                        </CTableDataCell>
                                        <CTableDataCell>
                                          {datas?.investor
                                            ? datas?.investor
                                            : "--"}
                                        </CTableDataCell>
                                        <CTableDataCell>
                                          <div
                                            style={{
                                              maxWidth: "150px", // Adjust max width as needed
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }}
                                            title={datas?.email} // Full content shown on hover
                                          >
                                            {datas?.email ? datas?.email : "--"}
                                          </div>
                                        </CTableDataCell>
                                        <CTableDataCell>
                                          {datas?.phoneNumber
                                            ? datas?.phoneNumber
                                            : "--"}
                                        </CTableDataCell>
                                        <CTableDataCell>
                                          {datas?.totalCapital || "-"}
                                        </CTableDataCell>
                                        <CTableDataCell>
                                          {datas?.totalLoanAmount || "-"}
                                        </CTableDataCell>
                                        <CTableDataCell>
                                          {datas?.paymentSums?.capital || "-"}
                                        </CTableDataCell>
                                        <CTableDataCell>
                                          {datas?.paymentSums?.loan || "-"}
                                        </CTableDataCell>
                                        <CTableDataCell>
                                          {datas?.paymentSums?.interest || "-"}
                                        </CTableDataCell>

                                        <CTableDataCell>
                                          {datas?.remainingBalance
                                            ?.capitalBalance || "-"}
                                        </CTableDataCell>
                                        <CTableDataCell>
                                          {datas?.remainingBalance
                                            ?.loanAmountBalance || "-"}
                                        </CTableDataCell>
                                      </CTableRow>
                                    );
                                  })
                              ) : (
                                <div className="loading_data">Loading...</div>
                              )}
                            </CTableBody>
                          </CTable>
                        </div>

                        <div className="pagin-div">
                          <div>
                            Showing {indexOfFirstRow + 1} to{" "}
                            {Math?.min(indexOfLastRow, Directors?.data?.length)}{" "}
                            of {Directors?.data?.length} entries
                          </div>
                          <div className="pagination-container">
                            <ReactPaginate
                              activePage={currentPage}
                              itemsCountPerPage={rowsPerPage}
                              totalItemsCount={
                                Directors?.data?.length
                                  ? Directors?.data?.length
                                  : 0
                              }
                              pageRangeDisplayed={5}
                              onChange={handlePageChange}
                              innerClass="pagination"
                              itemClass="page-item"
                              linkClass="page-link"
                            />
                          </div>
                        </div>
                      </div>
                    </CCardBody>
                  </CCard>
                </CCol>
                <CCol xs={12}></CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </>
  );
};

DirectorReports.propTypes = {
  pageFor: PropTypes.string,
};
export default DirectorReports;
